import { APP_INITIALIZER, Provider } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { StartupService } from '@core/bootstrap';
import { TranslateLangService } from '@core/bootstrap/translate-lang.service';

const startupServiceFactory = (startupService: StartupService) => {
  return () => startupService.load();
};

const translateLangServiceFactory = (
  translateLangService: TranslateLangService
) => {
  return () => translateLangService.load();
};

const matIconRegistryFactory = (matIconReg: MatIconRegistry) => {
  return () => matIconReg.setDefaultFontSetClass('material-icons');
};

export const appInitializerProviders: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: startupServiceFactory,
    deps: [StartupService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: translateLangServiceFactory,
    deps: [TranslateLangService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: matIconRegistryFactory,
    deps: [MatIconRegistry],
    multi: true,
  },
];
